export default __webpack_public_path__ + "static/media/mall-icon.0404b559.svg";